import React, { useEffect } from 'lib/react';
import { EVGrid } from 'lib/components';
import { useSelector, useDispatch } from 'lib/redux';
import {
  ORDER_PAGE_UPLOAD_BLUEPRINT_FILE,
  SET_SELECTED_PRODUCT,
  ORDER_PAGE_UPLOADING_BLUEPRINT_FILE,
  ORDER_PAGE_UPLOAD_BLUEPRINT_FILE_SUCCESS,
  ORDER_PAGE_UPLOAD_BLUEPRINT_FILE_ERROR,
} from 'constants/ActionTypes';
import UploadBlueprint from 'commonComponents/uploadBlueprint';
import { RESIDENTIAL, PRODUCT_IDS } from 'constants/AppConstants';
import { getProductFromId } from 'features/order/Order.utils';
import getResourceFileService from 'services/getResourceFile.service';
import { gainsightPxCustomEvent } from 'utils/gainsightPx.utils';
import { GAINSIGHT_PX_EVENT_BLUEPRINT_FILE_UPLOADED } from 'constants/gainsightPxCustomEvents.constants';
import BlueprintOrderPropertyDetailsPanel from './BlueprintOrderPropertyDetailsPanel.component';
import BlueprintOrderStyles from './BlueprintOrderStyles';

function BlueprintOrder() {
  const classes = BlueprintOrderStyles();

  const dispatch = useDispatch();

  const {
    bluePrintFileId: fileId, bluePrintFileData, uploadError, bluePrintFileName, uploadingBluePrintFile, userProducts,
  } = useSelector(({
    placeOrder, order, userData, nonPersisted: { orderBlueprintFileData },
  }) => ({
    ...placeOrder,
    bluePrintFileData: orderBlueprintFileData,
    uploadError: order.uploadBluePrintFileError,
    uploadingBluePrintFile: order.uploadingBluePrintFile,
    userProducts: userData.userProducts,
  }));

  useEffect(() => dispatch({
    type: SET_SELECTED_PRODUCT,
    updatedState: {
      selectedPrimaryProduct: getProductFromId(userProducts[RESIDENTIAL]?.PrimaryProducts || [], PRODUCT_IDS.BlueprintResidential),
      selectedPrimaryDeliveryProduct: 8,
      selectedWallsProduct: null,
      selectedWallsDeliveryProduct: null,
      selectedOtherProducts: {},
    },
  }), [userProducts]);

  useEffect(() => {
    if (fileId && !bluePrintFileData) {
      dispatch({ type: ORDER_PAGE_UPLOADING_BLUEPRINT_FILE });
      getResourceFileService(fileId).then((response) => {
        if (response.ok) {
          const { fileData } = response.json;
          dispatch({ type: ORDER_PAGE_UPLOAD_BLUEPRINT_FILE_SUCCESS, fileData });
        } else dispatch({ type: ORDER_PAGE_UPLOAD_BLUEPRINT_FILE_ERROR, error: 'Internal Server Error' });
      });
    }
  }, [fileId, bluePrintFileData]);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    gainsightPxCustomEvent(GAINSIGHT_PX_EVENT_BLUEPRINT_FILE_UPLOADED, { fileName: file.name });
    dispatch({ type: ORDER_PAGE_UPLOAD_BLUEPRINT_FILE, file });
  };

  return (
    <EVGrid container style={{ flex: 1 }}>
      <EVGrid className={classes.uploadBlueprintContainer}>
        <UploadBlueprint
          fileData={bluePrintFileData}
          fileName={bluePrintFileName}
          uploadError={uploadError}
          onFileUpload={handleFileUpload}
          isUploading={uploadingBluePrintFile}
        />
      </EVGrid>
      <BlueprintOrderPropertyDetailsPanel />
    </EVGrid>
  );
}

export default BlueprintOrder;
